/**
 * 接口文档
 * http://192.168.3.101/webot-dev/webot3/blob/xuwei/doc/api/%E4%B8%8A%E4%BC%A0%E6%8E%A5%E5%8F%A3.md
 */

import request from '@/utils/request'

/**
 * 上传一个图片/文件
 * @param { File } file
 */
export function uploadFile (file) {
    const formData = new FormData()
    formData.append('file', file)

    return request({
        url: 'chat/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    })
}

/**
 * 留言上传文件 上传一个图片/文件
 * @param { File } file
 */
export function levelUploadFile (file) {
    const formData = new FormData()
    formData.append('file', file)

    return request({
        url: 'chat/annex/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    })
}
